const doc = [({"en":({"js":({"nemoa_select":({"type_something_to_search":"Type something to search..."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;